import i18n from '@/i18n/i18n'
import { FaqService } from '@/services/admin/FaqService'

const { t } = i18n.global

export const namespaced = true

export const state = {
  faqs: []
}

export const mutations = {
  SET_FAQS(state, faqs) {
    state.faqs = faqs.data
  },
  ADD_FAQ(state, faq) {
    state.faqs.push(faq)
  },
  DELETE_FAQ(state, faqToRemove) {
    state.faqs = state.faqs.filter(faq => {
      return faq.id !== faqToRemove.id
    })
  },
  FLUSH_FAQS(state) {
    state.faqs = []
  }
}

export const actions = {
  getFaqs({ commit }, post) {
    return new Promise(resolve => {
      let faqService = new FaqService()

      faqService.getFaqs(post).then(response => {
        commit('SET_FAQS', response)
        resolve(response.data)
      })
    })
  },
  createFaq({ commit, dispatch }, data) {
    return new Promise(resolve => {
      let faqService = new FaqService()
      faqService.createFaq(data.post, data.faq).then(response => {
        const notification = {
          type: 'success',
          message: t('store.shared.added', {
            element: t('store.admin.faq.faq')
          })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  },
  updateFaq({ commit, dispatch }, data) {
    return new Promise(resolve => {
      let faqService = new FaqService()
      faqService.updatePost(data.post, data.faq).then(response => {
        const notification = {
          type: 'success',
          message: t('store.shared.updated', {
            element: t('store.admin.faq.questions')
          })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  },
  deleteFaq({ commit, dispatch }, data) {
    return new Promise(resolve => {
      let faqService = new FaqService()
      faqService.deleteFaq(data.post, data.faq).then(response => {
        commit('DELETE_FAQ', response.data)
        const notification = {
          type: 'warning',
          message: t('store.shared.deleted', {
            element: t('store.admin.faq.faq')
          })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  }
}
